import { useState } from "react";
import type { NextPage } from "next";
import Template from "@app/Template/Template";
import { configApi } from "@shared/lib/configApi";
import { RouterConfig } from "@shared/lib/routerConfig";
import { CustomHead, DEFAULT_OG_IMAGE } from "@shared/ui/CustomHead";
import classes from "@app/styles/pages/insurance.module.scss";

const Insurance: NextPage = () => {
    const [isLoading, setIsLoading] = useState(true);
    const hideSpinner = () => {
        setIsLoading(false);
    };

    return (
        <Template>
            <CustomHead
                title={"Оформите ОСАГО онлайн на likvi.com: выгодные цены и мгновенное оформление"}
                description={
                    "Likvi.com предлагает простой и выгодный способ оформления полиса ОСАГО онлайн. Мы предоставляем самые выгодные цены и мгновенное оформление электронного полиса Е-ОСАГО."
                }
                robots={"index,follow"}
                canonical={`${configApi.API_PUBLIC_DOMAIN}${RouterConfig.INSURANCE}`}
                openGraph={{
                    title: "Оформите ОСАГО онлайн на likvi.com: выгодные цены и мгновенное оформление",
                    description:
                        "Likvi.com предлагает простой и выгодный способ оформления полиса ОСАГО онлайн. Мы предоставляем самые выгодные цены и мгновенное оформление электронного полиса Е-ОСАГО.",
                    url: `${configApi.API_PUBLIC_DOMAIN}${RouterConfig.INSURANCE}`,
                    type: "website",
                    image: {
                        url: DEFAULT_OG_IMAGE,
                        width: 1200,
                        height: 630,
                        alt: "Оформите ОСАГО онлайн на likvi.com: выгодные цены и мгновенное оформление"
                    }
                }}
            />
            <div className={classes.InsuranceCont}>
                {!isLoading && (
                    <div className={classes.LogoCont}>
                        <svg
                            width="238"
                            height="36"
                            viewBox="0 0 238 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M0.487405 12.7952C0.218219 7.65886 4.16385 3.27678 9.30023 3.00759L57.3885 0.487392C62.5249 0.218206 66.9069 4.16384 67.1761 9.30021L67.9048 23.2047C68.174 28.3411 64.2284 32.7232 59.092 32.9924L4.60984 35.8477C3.00472 35.9318 1.63532 34.6988 1.5512 33.0937L0.487405 12.7952Z"
                                fill="#3B85F7"
                            />
                            <path
                                d="M11.4421 28.3219L10.4955 10.2592L13.7796 10.0871L14.7262 28.1498L11.4421 28.3219Z"
                                fill="white"
                            />
                            <path
                                d="M18.3654 27.9591L17.6947 15.1604L20.9788 14.9883L21.6495 27.787L18.3654 27.9591ZM19.2583 13.5777C18.6675 13.6087 18.1537 13.4458 17.7168 13.0892C17.2973 12.7317 17.0714 12.2433 17.0389 11.624C17.0064 11.0047 17.1801 10.4954 17.5599 10.096C17.9571 9.69569 18.4511 9.48005 19.0419 9.44909C19.6501 9.41722 20.1639 9.58003 20.5834 9.93755C21.0029 10.2951 21.2289 10.7835 21.2613 11.4028C21.2938 12.022 21.1201 12.5314 20.7403 12.9308C20.3605 13.3302 19.8665 13.5458 19.2583 13.5777Z"
                                fill="white"
                            />
                            <path
                                d="M25.2887 27.5962L24.3421 9.53356L27.6262 9.36145L28.1496 19.3475L28.6187 19.3229L32.6458 14.3768L36.9203 14.1528L31.2762 20.6585L37.7996 26.9406L33.5772 27.1618L28.7756 22.3162L28.3064 22.3408L28.5728 27.4241L25.2887 27.5962Z"
                                fill="white"
                            />
                            <path
                                d="M42.7115 26.6831L37.9226 14.1003L41.4152 13.9172L44.9589 24.1849L45.4281 24.1603L47.8791 13.5785L51.3717 13.3954L47.9243 26.4099L42.7115 26.6831Z"
                                fill="white"
                            />
                            <path
                                d="M54.2801 26.0769L53.6094 13.2782L56.8935 13.1061L57.5642 25.9047L54.2801 26.0769ZM55.173 11.6955C54.5822 11.7265 54.0684 11.5636 53.6315 11.207C53.212 10.8495 52.986 10.3611 52.9536 9.74183C52.9211 9.12254 53.0948 8.61319 53.4746 8.21379C53.8718 7.81348 54.3658 7.59784 54.9566 7.56688C55.5648 7.53501 56.0786 7.69783 56.4981 8.05534C56.9176 8.41285 57.1435 8.90125 57.176 9.52054C57.2085 10.1398 57.0348 10.6492 56.655 11.0486C56.2751 11.448 55.7811 11.6636 55.173 11.6955Z"
                                fill="white"
                            />
                            <path
                                d="M114 18.2265C114.001 16.3338 113.488 14.4778 112.517 12.8657C111.547 11.2535 110.158 9.94835 108.505 9.09579C106.851 8.24308 104.999 7.87641 103.154 8.03672C101.309 8.19688 99.5433 8.8775 98.0544 10.0029C96.5654 11.1284 95.4115 12.6542 94.7211 14.4107C94.0307 16.167 93.8309 18.0848 94.144 19.9504C94.4572 21.816 95.2709 23.556 96.4946 24.9766C97.7183 26.3972 99.3039 27.4426 101.075 27.9964V24.1239C99.9919 23.5681 99.0811 22.7166 98.443 21.6637C97.8048 20.611 97.4645 19.3981 97.4598 18.1597C97.455 16.9212 97.7861 15.7056 98.416 14.6477C99.0459 13.5899 99.9502 12.731 101.029 12.1665V18.3133L103.986 20.02L106.943 18.3133V12.1665C108.033 12.7231 108.949 13.5791 109.59 14.6381C110.231 15.6973 110.57 16.918 110.57 18.1632C110.57 19.4085 110.231 20.6291 109.59 21.6884C108.949 22.7476 108.033 23.6034 106.943 24.16V28C108.987 27.3561 110.775 26.0595 112.045 24.3005C113.315 22.5415 114 20.4127 114 18.2265Z"
                                fill="#227DF5"
                            />
                            <path
                                d="M119.281 18.9392V12.7037H122.497V18.8188C122.497 19.8299 123.169 20.6486 124.464 20.6486C125.76 20.6486 126.408 19.8299 126.408 18.8188V12.7037H129.623V18.9151C129.623 21.5393 127.992 23.4653 124.44 23.4653C120.937 23.4893 119.281 21.5633 119.281 18.9392Z"
                                fill="black"
                            />
                            <path
                                d="M137.108 23.2968L135.644 19.9744H134.492V23.2968H131.301V12.7037H136.94C139.411 12.7037 140.755 14.365 140.755 16.3391C140.755 18.1689 139.699 19.1318 138.859 19.5411L140.779 23.2727L137.108 23.2968ZM137.492 16.3391C137.492 15.7613 136.988 15.5205 136.436 15.5205H134.492V17.1817H136.436C136.964 17.1817 137.492 16.9169 137.492 16.3391Z"
                                fill="black"
                            />
                            <path
                                d="M142.027 23.297V12.7281H150.018V15.4967H145.219V16.5561H149.922V19.3488H145.219V20.5043H150.018V23.297H142.027Z"
                                fill="black"
                            />
                            <path
                                d="M160.643 23.297V16.9412L158.268 23.297H156.852L154.501 16.9412V23.297H151.285V12.7281H155.724L157.572 17.7838L159.42 12.7281H163.835V23.297H160.643Z"
                                fill="black"
                            />
                            <path
                                d="M234.527 23.297V16.9412L232.15 23.297H230.735L228.359 16.9412V23.297H225.168V12.7281H229.583L231.431 17.7838L233.302 12.7281H237.718V23.297H234.527Z"
                                fill="black"
                            />
                            <path
                                d="M164.945 17.9999C164.945 14.7499 167.441 12.535 170.68 12.535C173.92 12.535 176.415 14.7499 176.415 17.9999C176.415 21.25 173.92 23.4649 170.68 23.4649C167.441 23.4891 164.945 21.25 164.945 17.9999ZM173.176 17.9999C173.176 16.5314 172.192 15.3517 170.656 15.3517C169.121 15.3517 168.137 16.5314 168.137 17.9999C168.137 19.4685 169.121 20.6482 170.656 20.6482C172.192 20.6482 173.176 19.4927 173.176 17.9999Z"
                                fill="black"
                            />
                            <path
                                d="M212.453 17.9999C212.453 14.7499 214.949 12.535 218.188 12.535C221.427 12.535 223.923 14.7499 223.923 17.9999C223.923 21.25 221.427 23.4649 218.188 23.4649C214.949 23.4891 212.453 21.25 212.453 17.9999ZM220.684 17.9999C220.684 16.5314 219.7 15.3517 218.164 15.3517C216.628 15.3517 215.644 16.5314 215.644 17.9999C215.644 19.4685 216.628 20.6482 218.164 20.6482C219.7 20.6482 220.684 19.4927 220.684 17.9999Z"
                                fill="black"
                            />
                            <path
                                d="M184.599 23.297L180.687 17.9283V23.297H177.496V12.7281H180.783L184.455 17.7358V12.7281H187.67V23.297H184.599Z"
                                fill="black"
                            />
                            <path
                                d="M191.554 23.297V15.4967H188.746V12.7281H197.481V15.4967H194.697V23.297H191.554Z"
                                fill="black"
                            />
                            <path
                                d="M199.256 23.2961C198.32 23.2961 197.48 22.7426 197.48 21.5631C197.48 20.3837 198.32 19.8301 199.256 19.8301C200.215 19.8301 201.031 20.3837 201.031 21.5631C201.055 22.7426 200.215 23.2961 199.256 23.2961Z"
                                fill="black"
                            />
                            <path
                                d="M209.814 19.613C209.382 20.239 208.686 20.6482 207.775 20.6482C206.239 20.6482 205.255 19.4685 205.255 17.9999C205.255 16.5314 206.239 15.3517 207.775 15.3517C208.686 15.3517 209.382 15.761 209.814 16.4111L211.998 14.2202C210.966 13.1609 209.478 12.535 207.751 12.535C204.511 12.535 202.016 14.7499 202.016 17.9999C202.016 21.25 204.511 23.4649 207.751 23.4649C209.454 23.4649 210.942 22.839 211.974 21.8038L209.814 19.613Z"
                                fill="black"
                            />
                            <rect
                                x="84.2891"
                                y="14.1312"
                                width="1.26517"
                                height="10.1213"
                                transform="rotate(45 84.2891 14.1312)"
                                fill="#B5BCCB"
                            />
                            <rect
                                x="85.1836"
                                y="21.288"
                                width="1.26517"
                                height="10.1213"
                                transform="rotate(135 85.1836 21.288)"
                                fill="#B5BCCB"
                            />
                        </svg>
                    </div>
                )}
                {isLoading && <div className="custom-loader">loading</div>}
                <iframe
                    onLoad={hideSpinner}
                    className="insurance-iframe"
                    id="Iframe"
                    src="https://insurance.uremont.com/lk/calc?source=likvi"
                    title="страхование"
                ></iframe>
            </div>
        </Template>
    );
};

export default Insurance;